import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const TermAndConditionPageContainer = props => {
  return <LazyLoaderWrapper importPath='TERMS_AND_CONDITION_PAGE_ROUTE' {...props} />;
};

export default TermAndConditionPageContainer;
